/*import NotFound from '../pages/NotFoundPage.vue'
import SuccessPage from '../pages/SuccessPage.vue'
import HomePage from '../pages/HomePage.vue'
import Faq from '../pages/faq.vue'
import Planning from '../pages/planning.vue'
import Vip from '../pages/vip.vue'
import Decouvrir from '../pages/Decouvrir.vue'
import Decouvrir_alti from '../pages/Decouvrir_alti.vue'
import conferences from '../pages/conference.vue'
import Application from '../pages/application.vue'

import Press from '../pages/press.vue'
import Reservation from '../components/Reservation.vue'
import CheckoutStripeIban from '../components/CheckoutStripeIban.vue'
import PageCheckout from '../components/PageCheckout'
import PopUpCheckout from '../components/PopUpCheckout'
import CGV from '../pages/CGV.vue'
import ML from '../pages/ML.vue'
import PageCheckoutDiscover from '../components/PageCheckoutDiscover'
import PageCheckoutDiscover_alti from '../components/PageCheckoutDiscover_alti'
import PageCheckoutReplay from '../components/PageCheckoutReplay'
import bonus_darwin from '../pages/bonus_darwin.vue'
import bonus_klein from '../pages/bonus_klein.vue'
import bonus_clara from '../pages/bonus_clara.vue'
import bonus_cussac from '../pages/bonus_cussac.vue'
import bonus_deiss from '../pages/bonus_deiss.vue'
import bonus_delourmel from '../pages/bonus_delourmel.vue'
import bonus_donpierre from '../pages/bonus_donpierre.vue'
import bonus_khris from '../pages/bonus_khris.vue'
import bonus_morel from '../pages/bonus_morel.vue'
import bonus_roche from '../pages/bonus_roche.vue'*/
import BiffTheEnd from '../pages/BiffTheEnd.vue'

const routes = [
  {
    path: '/',
    component: BiffTheEnd,
    name: 'BiffTheEnd'
  },
  /*{
      path: '/',
      component: HomePage,
      name: 'HomePage'
  },
  {
      path: '/espace-reservation',
      component: Reservation,
      name: 'Reservation'
  },
  {
      path: '/faq',
      component: Faq,
      name: 'FAQ'
  },
  {
      path: '/application',
      component: Application,
      name: 'Application'
  },
  {
      path: '/planning',
      component: Planning,
      name: 'Planning'
  },
  {
      path: '/press',
      component: Press,
      name: 'Press'
  },
  {
      path: '/vip',
      component: Vip,
      name: 'Vip'
  },
  {
      path: '/checkout/success',
      component: SuccessPage,
      name: 'SuccessPage'
  },
  {
      path: '/checkout',
      component: CheckoutStripeIban,
      name: 'CheckoutStripeIban'
  },
  {
      path: '/billeterie-mobile',
      component: PageCheckout,
      name: 'PageCheckout',
      props: {showModal: true}
  },
  {
      path: '/billeterie',
      component: PopUpCheckout,
      name: 'PopUpCheckout',
      props: {showModal: true}
  },
  {
      path: '/cgv',
      component: CGV,
      name: 'CGV'
  },
  {
      path: '/mentions-legales',
      component: ML,
      name: 'ML'
  },
  {
      path: '/decouvrir',
  component: Decouvrir,
  name: 'Decouvrir'
},
  {
  path: '/decouvrir-alti',
  component: Decouvrir_alti,
  name: 'Decouvrir_alti'
},
  {
  path: '/replay-conferences-2019',
  component: conferences,
  name: 'Conferences'
},
  {
      path: '/bonus-darwin',
      component: bonus_darwin,
      name: 'bonus_darwin'
  },
  {
      path: '/bonus-yann-darwin',
      component: bonus_darwin,
      name: 'bonus_darwin'
  },
  {
      path: '/bonus-klein',
      component: bonus_klein,
      name: 'bonus_klein'
  },
  {
      path: '/bonus-morgane',
      component: bonus_clara,
      name: 'bonus_clara'
  },
  {
      path: '/bonus-cussac',
      component: bonus_cussac,
      name: 'bonus_cussac'
  },
  {
      path: '/bonus-deiss',
      component: bonus_deiss,
      name: 'bonus_deiss'
  },
  {
      path: '/bonus-delourmel',
      component: bonus_delourmel,
      name: 'bonus_delourmel'
  },
  {
      path: '/bonus-albertini',
      component: bonus_donpierre,
      name: 'bonus_donpierre'
  },
  {
      path: '/bonus-khris',
      component: bonus_khris,
      name: 'bonus_khris'
  },
  {
      path: '/bonus-morel',
      component: bonus_morel,
      name: 'bonus_morel'
  },
  {
      path: '/bonus-roche',
      component: bonus_roche,
      name: 'bonus_roche'
  },
  {
      path: '/tarifs-alti',
      component: PageCheckoutDiscover_alti,
      name: 'PageCheckoutDiscover_alti'
  },
  {
      path: '/tarifs',
      component: PageCheckoutDiscover,
      name: 'PageCheckoutDiscover'
  },
  {
      path: '/confirmation-replay-conferences-2019',
      component: PageCheckoutReplay,
      name: 'PageCheckoutReplay'
  },
  {path: '*', component: NotFound}*/
  {path: '*', component: BiffTheEnd}
]


/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
